import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataDtoModelBase } from './PlanningActionMetadataDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataDtoModel */
export interface PlanningActionMetadataDtoModelType extends Instance<typeof PlanningActionMetadataDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataDtoModel */
export { selectFromPlanningActionMetadataDto, planningActionMetadataDtoModelPrimitives, PlanningActionMetadataDtoModelSelector } from './PlanningActionMetadataDtoModel.base';

/**
 * PlanningActionMetadataDtoModel
 */
export const PlanningActionMetadataDtoModel = PlanningActionMetadataDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
